import Model from '@/core/models/Model';
import AvailableTrainingQualification from '@/modules/auth/models/AvailableTrainingQualification';
import TrainingQualification from '@/modules/auth/models/TrainingQualification';
import type { TrainingQualification as ITrainingQualification } from '@/modules/auth/types/TrainingQualification';
import type { Service } from '@/types/Service';

class TrainingQualificationService {
  getAvailableTrainingQualifications() {
    return useAsyncData<Service[]>(
      'available-training-qualifications',
      async () => {
        return Model.processResponse(await AvailableTrainingQualification.get()) as Service[];
      },
      { server: false }
    );
  }

  getTrainingQualifications() {
    return useAsyncData<{ abn: string; qualifications: any[] }>(
      'training-qualifications',
      async () => {
        const response = await TrainingQualification.get();
        const processedResponse = Model.processResponse(response);
        return processedResponse as { abn: string; qualifications: any[] };
      },
      { server: false }
    );
  }

  async createTrainingQualifications(form: { abn: string, qualifications: ITrainingQualification[] }) {
    const { data, error, execute } = useSubmit();
    await execute('worker/qualifications', {
      method: 'POST',
      body: {
        abn: form.abn,
        qualifications: form.qualifications,
      },
    });

    return {
      data,
      error,
    };
  }
}

const trainingQualificationService = new TrainingQualificationService();
export default trainingQualificationService;
